import { useEffect, useState } from "react";
import { useHistory } from "react-router";

import {
  initialPagination,
  initialSearchParams,
  PaginationType,
  SearchParams,
  useDebounce,
} from "helpers";
import { getArticles, Article } from "services/articles";

export const useArticlesPage = () => {
  const history = useHistory();

  const [data, setData] = useState<Article[]>([]);
  const [pagination, setPagination] =
    useState<PaginationType>(initialPagination);
  const [search, setSearch] = useState<SearchParams>(initialSearchParams);
  const debouncedValue = useDebounce(search.search);

  useEffect(() => {
    (async () => {
      const resp = await getArticles(pagination, search);
      setData(resp.data);
      setPagination((old) => ({
        ...old,
        totalRows: resp.meta.totalRows,
      }));
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue]);

  const onRowClick = (row: Article) => {
    history.push(`articles/${row.id}`);
  };

  const onNextClick = async () => {
    const newPagination = {
      ...pagination,
      currentPage: pagination.currentPage + 1,
    };
    const resp = await getArticles(newPagination, search);
    setData(resp.data);
    setPagination(newPagination);
  };

  const onPreviousClick = async () => {
    const newPagination = {
      ...pagination,
      currentPage: pagination.currentPage - 1,
    };
    const resp = await getArticles(newPagination, search);
    setData(resp.data);
    setPagination(newPagination);
  };

  const onTableHeaderClick = async (accessor: string) => {
    const newSearch: SearchParams = {
      ...search,
      sortBy: accessor,
      descending: search.sortBy === accessor ? !search.descending : true,
    };
    const resp = await getArticles(pagination, newSearch);
    setData(resp.data);
    setSearch(newSearch);
  };

  const onSearchChanged = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const pimpek = e.target.value;

    const newSearch: SearchParams = {
      ...search,
      search: pimpek.trim(),
    };

    setSearch(newSearch);
  };

  return {
    data,
    pagination,
    search,
    onRowClick,
    onNextClick,
    onPreviousClick,
    onSearchChanged,
    onTableHeaderClick,
  };
};
